<template>

    <div class="container-fluid">
        <div class="text-right mb-2">
            <button class="btn btn-primary" @click="openCreateModal">
                <font-awesome-icon :icon="['fas', 'plus']"/>
                {{ $t('global.buttons.add') }}
            </button>
        </div>
        <table-server :columns="table.columns" :options="tableOptions" :url="urlApps" class="text-center"
                      ref="table">
            <div class="table-name" slot="name" slot-scope="props" style="font-size: 0.9em">
                {{ props.row.name }}
            </div>
            <div class="table-icon" slot="icon" slot-scope="props" style="font-size: 0.9em">
                {{ props.row.icon }}
            </div>
            <div slot="menus_count" slot-scope="props">
                <span :class="props.row.menus_count > 0 ? 'badge-primary' : 'badge-light text-muted'"
                      class="badge badge-pill">
                    {{ props.row.menus_count }}
                </span>
            </div>
            <div class="table-actions" slot="actions" slot-scope="props" style="white-space: nowrap;padding: 5px;">
                <button @click="goToMenus(props.row.id)" class="btn btn-sm btn-outline-primary mr-1"
                        title="Ver menús">
                    <font-awesome-icon :icon="['fas', 'list-ol']"/>
                </button>
                <button @click="openEditModal(props.row)" class="btn btn-sm btn-outline-primary mr-1"
                        title="Editar">
                    <font-awesome-icon :icon="['fas', 'edit']"/>
                </button>
                <button @click="showDeleteModal(props.row.id,props.row.name)" class="btn btn-sm btn-outline-primary"
                        title="Eliminar">
                    <font-awesome-icon :icon="['fas', 'trash']"/>
                </button>
            </div>
            <div class="table-loading text-center" slot="loading">
                <img alt="loading" height="51px" src="/images/loading.svg"/>
            </div>
        </table-server>

        <b-modal :title="modalTitle" centered ref="form-modal">
            <form @submit.prevent="submitForm">
                <div class="form-group">
                    <label for="name">Nombre</label>
                    <input :class="{'form-control':true}" id="name" name="name" type="text"
                           v-model="form.name" v-validate="'required'">
                    <div class="bg-danger" style="margin-top: 3px;border-radius: 2px;" v-show="errors.has('name')">
                        <font-awesome-icon :icon="['fas', 'exclamation-circle']" style="margin-left: 5px;"/>
                        <span>{{ errors.first('name') }}</span>
                    </div>
                </div>
                <div class="form-group">
                    <label for="icon">Icono <small class="text-muted">(opcional)</small></label>
                    <input :class="{'form-control':true}" id="icon" name="icon" placeholder="ej: bars"
                           type="text" v-model="form.icon">
                </div>
            </form>
            <div slot="modal-footer">
                <button :disabled="saving" @click="submitForm" class="btn btn-success">
                    <span class="spinner-border spinner-border-sm mr-1" role="status" v-if="saving"></span>
                    {{ $t('global.buttons.submit') }}
                </button>
                <button :disabled="saving" @click="hideFormModal" class="btn btn-danger">
                    {{ $t('global.buttons.cancel') }}
                </button>
            </div>
        </b-modal>

        <b-modal :title="deleteName" centered ref="delete-modal" size="sm">
            <p class="text-center">{{ $t('global.message_delete') }}</p>
            <div slot="modal-footer">
                <button :disabled="deleting" @click="remove()" class="btn btn-success">
                    <span class="spinner-border spinner-border-sm mr-1" role="status" v-if="deleting"></span>
                    {{ $t('global.buttons.accept') }}
                </button>
                <button :disabled="deleting" @click="hideDeleteModal()" class="btn btn-danger">
                    {{ $t('global.buttons.cancel') }}
                </button>
            </div>
        </b-modal>
    </div>
</template>

<script>
import {API} from './../../../api'
import TableServer from '../../../components/TableServer'
import BModal from 'bootstrap-vue/es/components/modal/modal'

export default {
    components: {
        'table-server': TableServer,
        BModal
    },
    data: () => {
        return {
            deleteName: '',
            deleteId: null,
            urlApps: '/api/apps?token=' + window.localStorage.getItem('access_token') + '&lang=' +
                localStorage.getItem('lang'),
            table: {
                columns: ['id', 'name', 'icon', 'menus_count', 'actions'],
            },
            formAction: 'post',
            editingId: null,
            modalTitle: 'Nueva app',
            saving: false,
            deleting: false,
            form: {
                name: '',
                icon: ''
            }
        }
    },
    computed: {
        tableOptions: function () {
            return {
                headings: {
                    id: 'ID',
                    name: this.$i18n.t('global.name'),
                    icon: 'Icono',
                    menus_count: 'Menús',
                    actions: this.$i18n.t('global.table.actions')
                },
                sortable: ['id'],
                filterable: ['id']
            }
        }
    },
    mounted() {
        this.$i18n.locale = localStorage.getItem('lang')
    },
    methods: {
        goToMenus(appId) {
            this.$router.push({name: 'MenusList', params: {app_id: appId}})
        },
        openCreateModal() {
            this.formAction = 'post'
            this.editingId = null
            this.modalTitle = 'Nueva app'
            this.form = {name: '', icon: ''}
            this.errors.clear()
            this.$refs['form-modal'].show()
        },
        openEditModal(row) {
            this.formAction = 'put'
            this.editingId = row.id
            this.modalTitle = 'Editar app'
            this.form = {name: row.name, icon: row.icon}
            this.errors.clear()
            this.$refs['form-modal'].show()
        },
        hideFormModal() {
            this.$refs['form-modal'].hide()
        },
        submitForm() {
            this.$validator.validateAll().then((result) => {
                if (!result) {
                    this.$notify({
                        group: 'main',
                        type: 'error',
                        title: 'Apps',
                        text: this.$t('servicetypes.error.messages.information_complete')
                    })
                    return
                }
                this.saving = true
                API({
                    method: this.formAction,
                    url: 'apps/' + (this.editingId !== null ? this.editingId : ''),
                    data: this.form
                }).then((result) => {
                    this.saving = false
                    if (result.data.success === false) {
                        this.$notify({
                            group: 'main',
                            type: 'error',
                            title: 'Apps',
                            text: this.$t('servicetypes.error.messages.information_error')
                        })
                    } else {
                        this.hideFormModal()
                        this.onUpdate()
                        this.$notify({
                            group: 'main',
                            type: 'success',
                            title: 'Apps',
                            text: this.editingId !== null ? 'App actualizada' : 'App creada'
                        })
                    }
                }).catch(() => {
                    this.saving = false
                    this.$notify({
                        group: 'main',
                        type: 'error',
                        title: 'Apps',
                        text: this.$t('servicetypes.error.messages.connection_error')
                    })
                })
            })
        },
        showDeleteModal(app_id, app_name) {
            this.deleteId = app_id
            this.deleteName = app_name
            this.$refs['delete-modal'].show()
        },
        hideDeleteModal() {
            this.$refs['delete-modal'].hide()
        },
        remove() {
            this.deleting = true
            API({
                method: 'DELETE',
                url: 'apps/' + this.deleteId
            })
                .then((result) => {
                    this.deleting = false
                    if (result.data.success === true) {
                        this.onUpdate()
                        this.hideDeleteModal()
                    } else {
                        this.hideDeleteModal()
                        if (result.data.used === true) {
                            this.$notify({
                                group: 'main',
                                type: 'error',
                                title: 'Apps',
                                text: 'La app no puede ser eliminada, ya que tiene menús asociados'
                            })
                        }
                    }
                }).catch(() => {
                this.deleting = false
                this.$notify({
                    group: 'main',
                    type: 'error',
                    title: 'Apps',
                    text: this.$t('servicetypes.error.messages.connection_error')
                })
            })
        },
        onUpdate() {
            this.urlApps = '/api/apps?token=' + window.localStorage.getItem('access_token') + '&lang=' +
                localStorage.getItem('lang')
            this.$refs.table.$refs.tableserver.refresh()
        },
    }

}
</script>

<style lang="stylus">

</style>
